import React from 'react';
import './MetOurTeam.css'
import Subtitle from '../components/Subtitle';
import Title from '../components/Title';
import Paragraph from '../components/Paragraph';
import Button from '../components/Button';

const MetOurTeam = () => {
    return ( <>
    <section className='section5'>
    <div className='text-container2'>
        <Subtitle text='Our Attorneys' css3='subtitle'/>
        <Title text1='Meet Our Team' css2='text2'/>
        <div className='line4'></div>
        <Paragraph text2='Experienced legal professionals dedicated to protecting your interests with integrity, expertise, and unwavering commitment.' css7='paragraph5'/>
        <Button text='View All' css4='button'/>
        </div>
    </section>
    </> );
}
 
export default MetOurTeam;